import { MrCarousel } from '@mrhenry/wp--mr-interactive';

class MrCarouselFormatted extends MrCarousel {
	override get value() {
		return super.value.split( '/' ).map( ( x ) => {
			return x.padStart( 2, '0' );
		} ).join( '/' );
	}
}

customElements.define( 'mr-carousel', MrCarouselFormatted );
